import React, {useEffect, useState} from "react";

const HorizontalForm = props => {

    const [profile, setProfile] = useState({
        "firstname": "",
        "lastname": "",
        "email": ""
    });


    const buttonBack = {
        backgroundColor: '#563c91',
        color: 'white'
    };

    useEffect(() => {
        fetch('/service/me')
        .then(res => res.json())
        .then(data => setProfile(data))
    }, []);

    const handleSubmit = (e) => {
        fetch('/service/me', {
            method: 'PATCH',
            body: JSON.stringify(profile)
        })
        .then(res => res.json())
        .then(data => console.log(data))

        e.preventDefault();

    }

    const handleChange = e => {
        const target = e.target;
        setProfile({ ...profile, [target.name] : target.value})
    }

    return (
        <div>
            <form>
                <div className="form-group row">
                    <label className="col-sm-4 col-form-label">
                        First Name
                    </label>
                    <div className="col-sm-8">
                        <input
                            type="text"
                            className="form-control react-form-input"
                            aria-describedby="emailHelp"
                            id="firstname"
                            name="firstname"
                            placeholder="First Name"
                            onChange={handleChange}
                            value={profile.firstname}
                        />
                    </div>
                </div>

                <div className="form-group row">
                    <label className="col-sm-4 col-form-label">Last Name</label>
                    <div className="col-sm-8">
                        <input
                            type="text"
                            className="form-control react-form-input"
                            aria-describedby="emailHelp"
                            id="lastname"
                            name="lastname"
                            placeholder="Last Name"
                            onChange={handleChange}
                            value={profile.lastname}

                        />
                    </div>
                </div>

                <div className="form-group row">
                    <label className="col-sm-4 col-form-label">Email</label>
                    <div className="col-sm-8">
                        <input
                            type="email"
                            className="form-control react-form-input"
                            aria-describedby="emailHelp"
                            id="email"
                            name="email"
                            placeholder="email"
                            onChange={handleChange}
                            value={profile.email}

                        />
                    </div>
                </div>
{/*
                <div className="form-group row">
                    <label className="col-sm-4 col-form-label">Password</label>
                    <div className="col-sm-8">
                        <input
                            type="password"
                            className="form-control react-form-input"
                            placeholder="Password"
                            autoComplete=""
                        />
                    </div>
                </div>
*/}
                <button
                    style={buttonBack}
                    type="submit"
                    className="btn form-button"
                    onClick={handleSubmit}
                >
                    Submit
                </button>
            </form>
        </div>
    );
};

export default HorizontalForm;
